import React from 'react';
import Table from './Table';

const formatUpdatedDate = (value) => {
  if (!value) return null;

  const dateOnlyParts = typeof value === 'string'
    ? value.match(/^(\d{4})-(\d{2})-(\d{2})/)
    : null;
  const date = dateOnlyParts
    ? new Date(Date.UTC(
      Number(dateOnlyParts[1]),
      Number(dateOnlyParts[2]) - 1,
      Number(dateOnlyParts[3])
    ))
    : new Date(value);

  if (Number.isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...(dateOnlyParts ? { timeZone: 'UTC' } : {}),
  }).format(date);
};

const Section = ({
  method,
  data,
  updatedAt,
  loading,
  error,
  hasQuery,
  title = 'Opportunities',
  description = 'Companies trading below their estimated fundamental value.',
}) => {
  const updatedDate = formatUpdatedDate(updatedAt);

  return (
    <section className="results-section" aria-labelledby="results-heading">
      <div className="section-heading">
        <div>
          <h2 id="results-heading">{title}</h2>
          <p>{description}</p>
        </div>
        {!loading && !error && (
          <div className="section-meta">
            {updatedDate && (
              <time className="last-updated" dateTime={String(updatedAt)}>
                Last updated {updatedDate}
              </time>
            )}
            <span className="result-count">
              {data.length} {data.length === 1 ? 'company' : 'companies'}
            </span>
          </div>
        )}
      </div>

      {loading && (
        <div className="status-panel" role="status">
          <span className="loader" />
          <div>
            <strong>Loading valuations</strong>
            <p>Finding companies with a margin of safety.</p>
          </div>
        </div>
      )}

      {!loading && error && (
        <div className="status-panel error-panel" role="alert">
          <span className="status-icon">!</span>
          <div>
            <strong>We couldn’t load the valuations</strong>
            <p>{error.message}</p>
          </div>
        </div>
      )}

      {!loading && !error && (
        <Table data={data} method={method} hasQuery={hasQuery} />
      )}
    </section>
  );
};

export { formatUpdatedDate };
export default Section;
